import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "src/environments/environment";
import {SessionStorageService} from "../shared/services/session-storage.service";
import {FacadeService} from "../shared/service-facade/facade.service";
import { DatePipe } from "@angular/common";

@Injectable()
export class BearerTokenInterceptor implements HttpInterceptor {
  constructor(
    private sessionStorageService: SessionStorageService,
    private facadeService: FacadeService,
    private datePipe: DatePipe
  ) {
  }

  private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.sessionStorageService.token;

    // Generate UUID for request ID
    const requestId = this.generateUUID();
    
    // Generate current UTC timestamp in format YYYY-MM-DDThh:mm:ss.SSS using DatePipe
    let utcTimestamp = this.datePipe.transform(new Date(), "yyyy-dd-MM'T'HH:mm:ss.SSS", 'UTC') ?? '';
    if (!utcTimestamp) {
      utcTimestamp = new Date().toISOString();
    }

    if (token && (environment.local || request.url.includes(environment.api_base_url))) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          'Pragma': 'no-cache',
          'Expires': '0',
          'x-app-key' : `${this.facadeService.getSessionId()}`,
          'x-tc-request-id': requestId,
          'x-tc-utc-timestamp': utcTimestamp
        }
      });
    }

    return next.handle(request);
  }

}
